import React, { FC } from "react";

import { Loader } from "@components/Loader";
import { MainLayout } from "@layouts/MainLayout";

interface LoadingPageProps {
  className?: string;
  style?: React.CSSProperties;
}

export const LoadingPage: FC<LoadingPageProps> = (props) => {
  const { ...restProps } = props;

  return (
    <MainLayout {...restProps}>
      <Loader size={50} isCenter showLoadingTitle margin={[50, 0, 400, 0]} />
    </MainLayout>
  );
};
